// Column sorting for the shared table: the header labels carry the arrow, a click on a header flips or changes the key.
const ARROWS = { asc: ' \u2191', desc: ' \u2193' }
const TEXT_KEYS = ['user', 'ticker', 'side'] // a first click sorts text A to Z, figures biggest first

export const sortedHead = (columns, label, sort) => columns.map((key) => label(key) + (sort?.key === key ? ARROWS[sort.dir] : ''))

// the shared table hands back the label that was clicked: find the column behind it, ignore the ones that do not sort
export const sortFromHead = (clicked, columns, label, sort, sortable) => {
  const key = columns.find((column) => clicked === label(column) || clicked === label(column) + ARROWS.asc || clicked === label(column) + ARROWS.desc)
  if (!key || !sortable.includes(key)) return sort
  if (sort?.key === key) return { key, dir: sort.dir === 'asc' ? 'desc' : 'asc' }
  return { key, dir: TEXT_KEYS.includes(key) ? 'asc' : 'desc' }
}
